// Video gallery (YouTube links or direct .mp4 files). `thumb` is optional — YouTube thumbnails are used automatically.
const videos = [
  { id: 1, title: "Unity Health Centre — Introduction", url: "https://www.youtube.com/watch?v=nrJtHemSPW4", thumb: "" },
];

export const videosContent = {
  title: "Our Videos",
  subtitle: "Take a look at our facility and awareness programmes.",
};

export default videos;
